<div class="sidebar-wrapper {{buttonName}}">
  <div class="leftSidebarButton">
    <button (click)="toggle()" id="bt" class="tr-btn">

      <i class="fa fa-angle-right"></i>
    </button>
    <!-- <a href="javascript:void(0)" class="btn tr-btn tr-btn ">
      <i class="fa fa-angle-right"></i>
    </a> -->
  </div>
  <div class="sidebar-content">
    <!-- <div class="sidebar-logo niit-logo-icon">
          <a href="javascript:void(0)" title="NIIT"><img src="assets/logo.svg" class="img-responsive"></a>
      </div> -->
    <ul class="sidebar-content-list">
      <li class="" [routerLinkActive]="['active']">
        <a title="Interested Applicant" *ngIf="userRoll==3" [routerLink]="['/interested-users']"
          class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fa fa-user-circle"></i>
          </span>
          <span class="sd-iconLabel">Interested
            <br> Applicant</span>
        </a>
      </li>
      <li class="" [routerLinkActive]="['active']">
        <a title="TR Nominees" [routerLink]="['/addResource']" class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fa fa-user"></i>
          </span>
          <span class="sd-iconLabel">TR <br> Nominees</span>
        </a>
      </li>
      <li class="" [routerLinkActive]="['active']">
        <a title="Manager Section" [routerLink]="['/managerRating']" *ngIf="userRoll==4"
          class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fas fa-user-shield"></i>
          </span>
          <span class="sd-iconLabel">Manager Section</span>
        </a>
      </li>
      <li class="" [routerLinkActive]="['active']">
        <a title="Compute Score" [routerLink]="['/scoreComputation']" class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fas fa-star"></i>
          </span>
          <span class="sd-iconLabel">Compute Score</span>
        </a>
      </li>
      <!-- <li class="" [routerLinkActive]="['active']">
        <a title="Admin Section" [routerLink]="['/adminDashboard']" *ngIf="userRoll==4" class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fas fa-user-lock"></i>
          </span>
          <span class="sd-iconLabel">Admin</span>
        </a>
      </li> -->
      <li class="" [routerLinkActive]="['active']">
        <a title="Dashboard" [routerLink]="['/userDashboard']" class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fas fa-chart-bar"></i>
          </span>
          <span class="sd-iconLabel">Dashboard</span>
        </a>
      </li>
      <li class="" [routerLinkActive]="['active']">
        <a title="Interventions" *ngIf="userRoll==3" [routerLink]="['/intervention']" class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fas fa-bars"></i>
          </span>
          <span class="sd-iconLabel">Interventions</span>
        </a>
      </li>
      <li class="" [routerLinkActive]="['active']">
        <a title="Management User" *ngIf="userRoll==1" [routerLink]="['/manageUsers']"
          class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fas fa-user-tie"></i>
          </span>
          <span class="sd-iconLabel">Management User</span>
        </a>
      </li>
      <li class="" [routerLinkActive]="['active']">
        <a title="Functional Skill Config" *ngIf="userRoll==3" [routerLink]="['/funSkillMaster']"
          class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fa fa-tasks"></i>
          </span>
          <span class="sd-iconLabel">Functional Skill Config</span>
        </a>
      </li>
      <li class="" [routerLinkActive]="['active']">
        <a title="Behavioral Skill Config" *ngIf="userRoll==3" [routerLink]="['/behSkillMaster']"
          class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fa fa-user-cog"></i>
          </span>
          <span class="sd-iconLabel">Behavioral Skill Config</span>
        </a>
      </li>
      <li class="" [routerLinkActive]="['active']">
        <a title="User Rating History" *ngIf="userRoll==3 || userRoll==4 || userRoll==7"
          [routerLink]="['/rating-history']" class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fa fa-history"></i>
          </span>
          <span class="sd-iconLabel">Rating History</span>
        </a>
      </li>
      <li  class="" *ngIf="userRoll==3 || userRoll==7" [routerLinkActive]="['active']"><a 
          title="Competency Report" class="sidebar-content-list-icon" [routerLink]="['/competencyReport']"><span
             class="sd-icon"><i  class="fa fa-list-alt"></i></span><span
             class="sd-iconLabel">Competency Report</span></a>
            </li>
      <!-- <li class="" [routerLinkActive]="['active']" *ngIf="userRoll==3">
        <a title="Role Ladder" [routerLink]="['/position-ladder']" class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fas fa-level-up-alt"></i>
          </span>
          <span class="sd-iconLabel">Role Ladder</span>
        </a>
      </li>
      <li class="" [routerLinkActive]="['active']" *ngIf="userRoll==3">
        <a title="Training" [routerLink]="['/training']" class="sidebar-content-list-icon">
          <span class="sd-icon">
            <i class="fas fa-chalkboard-teacher"></i>
          </span>
          <span class="sd-iconLabel">Training</span>
        </a>
      </li> -->
    </ul>
  </div>
</div>